// extracted by mini-css-extract-plugin
export default {"root":"IconBillList_root__xFo+J"};